import { render } from "./Pending.vue?vue&type=template&id=cbeced9c"
import script from "./Pending.vue?vue&type=script&lang=js"
export * from "./Pending.vue?vue&type=script&lang=js"

import "./Pending.vue?vue&type=style&index=0&id=cbeced9c&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__